/*
* Created By Jaeuk Ryu <devp011>
*/
export const state = () => ({
  url: '/api/sm/external/signtr/server',
  // === Table Contents  ===
  rowSelectItems: [],
  dataList: [],

  // ********************************************************************************************************************
  /*  on off 에 의해서 필수값이 필수값이 아니게 된경우 다음과 같이 초기화 한다.
  Object type = [] Array type = {} Int, Ip = null String = ''
  위와 같이 초기화 하는경우는, 원본을 손대지 않고, _.CloneDeep 기능을 이용해서 변환한 데이터를 서버로 보낸다.
  0. 변환이 반드시 필요한 경우 // 뒤에 (*) 를 표시해두었다. 내용이 보기 어려운 경우 (*) 라도 주의해서 보는것이 좋다.
  1. NEED TO COVERT null
    null 이 들어올 수 있고,
    보낼 때 ON/OFF 등에 의해 필요 없게 되었을 때, null 로 변환해서 보내야 하는 경우를 표시한다.
  2. NEED TO CONVERT {} 또는 []
    들어올 때는 {} 또는 [] 가 들어올 수 있고
    보낼 때 ON/OFF 등에 의해 필요 없게 되었을 때나, 설정을 하지 않은경우,
    안에 값을 남기지 않고 {} 또는 [] 로 비워서 보내야 하는 경우를 표시한다.
  3. << KEY >> (파라미터 자신이, ON OFF 의 KEY 가 되는 경우)
  4. << parameter name >> (파라미터 자신에게 영향을 끼치는 ON OFF 의 KEY 를 기재)
  5. DEFAULT (기본값을 표시해야 하는 경우)
  6. NOT NULL (필수 항목이어서 null 로 주고 받지 않는 경우)
  7. NUM, IP (number 나 IP 타입이어서 null 로 들어올 수 있고, 보낼 때, '' 인 경우 null 로 변환해서 보내야 하는 경우)
  8. UnUsed 주고 받기는 하나 사용하지 않는 파라미터
  */
  // ********************************************************************************************************************
  detailPopUpData: {
    signtr_server_auth_code: '',
    signtr_server_type: '',
    signtr_server_desc: '',
    signtr_server_id: null,
    signtr_server_ip: '',
    signtr_server_port: null,
    signtr_server_sched_set: {'sched_type': 0, 'sched_hour': 0, 'sched_min': 0},
    signtr_server_uname: ''
  }
})

export const mutations = {
  setRowSelectItems (state, data) {
    state.rowSelectItems = data
  },
  clearDetailPopup (state) {
    state.detailPopUpData = {
      signtr_server_auth_code: '',
      signtr_server_type: 1,
      signtr_server_desc: '',
      signtr_server_id: null,
      signtr_server_ip: '',
      signtr_server_port: null,
      signtr_server_sched_set: {'sched_type': 0, 'sched_hour': 0, 'sched_min': 0},
      signtr_server_uname: ''
    }
  },
  getTableList (state, data) {
    state.dataList = _.cloneDeep(data.result)
    state.dataList.forEach((item) => {
      item.signtr_server_sched_set = JSON.parse(item.signtr_server_sched_set)
    })
  },
  getDetailDataList: (state, data) => {
    state.detailPopUpData = data.result[0]
    // state.detailPopUpData.signtr_server_sched_set = (JSON.parse(data.result[0].signtr_server_sched_set).length > 0)
    //   ? JSON.parse(data.result[0].signtr_server_sched_set)[0] : {'sched_type': 0, 'sched_hour': 0, 'sched_min': 0}
    state.detailPopUpData.signtr_server_sched_set = JSON.parse(data.result[0].signtr_server_sched_set)
  }
}

export const actions = {
  // 메인 테이블
  async getTableList ({commit, state}) {
    try {
      const data = await this.$axios.$get(state.url)
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      commit('getTableList', data)
      return {code: 'ok'}
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  async getDetailDataList ({commit, state}) {
    try {
      const data = await this.$axios.$get(`${state.url}?signtr_server_id=${state.rowSelectItems[0].signtr_server_id}`, {successAlert: false})
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      commit('getDetailDataList', data)
      return {code: 'ok'}
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  async addTableList ({commit, state}, payload) {
    try {
      const param = _.cloneDeep(state.detailPopUpData)
      const axiosData = _.omit(param, ['signtr_server_id'])
      axiosData.cfg_admin_id = payload
      // axiosData.signtr_server_sched_set = JSON.stringify([param.signtr_server_sched_set])
      axiosData.signtr_server_sched_set = JSON.stringify(param.signtr_server_sched_set)

      const data = await this.$axios.$post(state.url, axiosData, {loading: false, successAlert: false})
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      return {code: 'ok'}
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  async edtTableList ({commit, state}, payload) {
    try {
      const axiosData = _.cloneDeep(state.detailPopUpData)
      axiosData.cfg_admin_id = payload
      // axiosData.signtr_server_sched_set = JSON.stringify([axiosData.signtr_server_sched_set])
      axiosData.signtr_server_sched_set = JSON.stringify(axiosData.signtr_server_sched_set)

      const data = await this.$axios.$put(state.url, axiosData, {loading: false, successAlert: false})
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      return {code: 'ok'}
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  async delTableList ({commit, state}) {
    let isMulty = false
    if (state.rowSelectItems.length > 1) {
      isMulty = true
    }
    const idList = []
    for (const item of state.rowSelectItems) {
      idList.push(item.signtr_server_id)
    }
    const axiosData = JSON.stringify(idList)
    try {
      const data = await this.$axios.$delete(`${state.url}?signtr_server_id_list=${axiosData}`, {successAlert: false})
      if (data.code !== 'ok') {
        if (isMulty) {
          return {code: 'pok', errors: data.result.msg}
        }
        return {code: 'nok', errors: data.result.msg}
      }
      return {code: 'ok'}
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  async commitAndRollBackPage ({commit, state}, type) {
    try {
      let msg = {}
      if (type === 'apply') {
        msg = {applyMsg: true}
      } else if (type === 'cancel') {
        msg = {cancelMsg: true}
      }
      const data = await this.$axios.$put(`${state.url}/${type}`, null, msg)
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      return {code: 'ok'}
    } catch (error) {
      return {code: 'error', errors: error}
    }
  }
}

export const getters = {}
export const strict = false
